<template>
  <b-container class="p-0" fluid="true">

    <b-row v-if="!foreignEntityName" class="pt-3 pl-3 no-gutters font-weight-bold">
      <b-col cols="auto">{{ changeEvent.uNm }}</b-col>
      <b-col cols="auto" class="pr-2 pl-2">{{ changeEvent.chgTp }}</b-col>
      <b-col cols="auto">{{ changeEvent.ts }}</b-col>
    </b-row>

    <b-row  v-if="changeEvent.chgs[0].t === 'f_d'" class="pt-3 pl-3 no-gutters font-weight-bold">
      <b-col cols="auto" class="pr-2 pl-2">{{ changeEvent.chgTp }}  from {{entityLabel}} </b-col>
      <b-col cols="auto">by  {{ changeEvent.uNm }}</b-col>
      <b-col cols="auto" class="pl-2">{{ changeEvent.ts }}</b-col>
    </b-row>

    <b-row  v-if="changeEvent.chgs[0].t === 'f_a'" class="pt-3 pl-3 no-gutters font-weight-bold">
      <b-col cols="auto" class="pr-2 pl-2">{{ changeEvent.chgTp }}  to  {{entityLabel}}</b-col>
      <b-col cols="auto">by  {{ changeEvent.uNm }}</b-col>
      <b-col cols="auto" class="pl-2">{{ changeEvent.ts }}</b-col>
    </b-row>
    <hr>

    <b-row no-gutters class="pl-3 pt-2" v-if="foreignEntityName">
      <b-col>{{foreignEntityName}} moved: {{changeEvent.chgs[0].eL}}</b-col>
    </b-row>


    <b-row no-gutters class="pl-3 pt-2" v-for="changeRecord in changeItems" :key="changeRecord.id">

      <!-- zmiany jakiegos pola -->
        <b-col cols="12 " v-if="changeRecord.pth">
          <span class="font-weight-bold" v-for="path in changeRecord.pth">{{ path.l }}  </span>
        </b-col>
        <b-col cols="auto" class="pl-3 pt-1" v-if="changeRecord.pth">
          <span v-if="changeRecord.fS !== null"> {{ changeRecord.fS }}</span>
          <ValueRenderer v-else :change-record="changeRecord" :value="changeRecord.fV"></ValueRenderer>
        </b-col>
        <b-col cols="auto" class="pl-3 pr-3 pt-1" v-if="changeRecord.pth">
          <font-awesome-icon icon="arrow-right"></font-awesome-icon>
        </b-col>
        <b-col cols="auto" class="pt-1" v-if="changeRecord.pth">
          <span v-if="changeRecord.valStr !== null"> {{ changeRecord.valStr }}</span>
          <ValueRenderer v-else :change-record="changeRecord" :value="changeRecord.val"></ValueRenderer>
        </b-col>

      <!--  -->

      <!-- zmiany na powiazanym elemencie -->
      <!-- TODO można dodać linka do zmienianego rekordu -->
      <b-col cols="12 " v-if="!changeRecord.pth">
        <span v-if="changeRecord.t === 'f_u'"><span class="font-weight-bold">Connected record updated: </span> {{ changeRecord.eLchg }}  </span>
        <span v-if="changeRecord.t === 'f_d'"><span class="font-weight-bold">Connected record deleted: </span> {{ changeRecord.eL }}  </span>
        <span v-if="changeRecord.t === 'f_a'"><span class="font-weight-bold">Connected record added: </span> {{ changeRecord.eLchg }}  </span>
      </b-col>

    </b-row>

    <b-row no-gutters class="pl-3 pt-2" v-for="change in changeItemsOnList" :key="change.key">
      <b-col cols="12" class="pl-1">
        <span class="font-weight-bold">{{ change.displayPath }}</span>
      </b-col>
      <b-col cols="12" v-if="change.event.addedItems.length" class="pl-3">
        <span class="font-weight-bold">Added:</span>
      </b-col>
      <b-col cols="auto" v-if="change.event.addedItems.length" class="pl-5 pt-1">
        <ValueRenderer :change-record="change.chg" :value="change.event.addedItems"></ValueRenderer>
      </b-col>
      <b-col cols="12" v-if="change.event.deletedItems.length" class="pl-3">
        <span class="font-weight-bold">Deleted:</span>
      </b-col>
      <b-col cols="auto" v-if="change.event.deletedItems.length" class="pl-5 pt-1">
        <ValueRenderer :change-record="change.chg" :value="change.event.deletedItems"></ValueRenderer>
      </b-col>
    </b-row>

  </b-container>
</template>
<script>
import Activity from "@/activity/Activity";
import ValueRenderer from "@/components/forms/renderers/ValueRenderer";
import ChangeEventListItem from "@/components/audit-log/ChangeEventListItem";

export default {
  name: "AuditLogDetails",
  components: {ValueRenderer},

  async mounted() {
    if(!this.foreignEntityName){
      this.setLists();
    }
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return this.entityLabel + $tr('historyDetails',' history details') ;
    },

    setLists(){
      let listChangesDictionary = new Map();
      for (let chg of this.changeEvent.chgs) {
        let event;
        let displayPath = "";
        let key = "";
        if (chg.pth) {
          for (let pth of chg.pth) {
            if (pth.t === "p") {
              if (key !== "") {
                key += ".";
                displayPath += "/"
              }
              key += pth.nm;
              displayPath += pth.l;
            } else if (pth.t === "i") {
              key += "[" + pth.i + "]";
              displayPath += "[" + (pth.i + 1) + "]";
            } else if (pth.t === "k") {
              key += "[" + pth.k + "]";
              displayPath += "[" + pth.k + "]";
            }
          }
        }
        if (!(listChangesDictionary.has(key))) {
          event = new ChangeEventListItem();
          listChangesDictionary.set(key, event);
        } else {
          event = listChangesDictionary.get(key);
        }

        if (chg.t === "ld") {
          event.deletedItems.push(chg.val);
        } else if (chg.t === "la" || chg.t === "ldp" || chg.t === "lm") {
          event.addedItems.push(chg.val);
        } else {
          this.changeItems.push(chg);
          continue;
        }
        let findKey = _.find(this.changeItemsOnList, {key: key});
        if (!findKey) {
          this.changeItemsOnList.push({key, event, displayPath, chg});
        }
      }
    }

  },

  props: {
    entityInstance: {default: null},
    foreignEntityName: {default: null},
    entityLabel: {type: String, default: ""},
    changeEvent: {default: null},
  },


  data: () => ({
    changeItemsOnList: [],
    changeItems: []
  }),

}
</script>
